import { apiRequest } from "@/services/api-client";
import { ListPacksOutput, WebAppRoutes } from "types/web-app";

export const listPacks = () =>
  apiRequest<ListPacksOutput>("/" + WebAppRoutes.LIST_PACKS);
